<template>
<div class="sk-loader" v-if="loading">
  <div v-for="idx in repeat" :key="idx"  class="sk-loader-child">
    <slot></slot>
    </div>
    <div class="sk-loader-loading" :style="{animationDuration:speed}" />
  
</div>
</template>

<script>
    export default {
        // relating to the attribute define in outer <router-view> tag.
        props: {repeat:{type:Number,default:1},loading:{type:Boolean,default:true},speed:{type:String,default:"1.5s"}},
        data: function () {
            return {
            };
        }
    }
</script>
<style lang="scss">
@keyframes placeHolderShimmer {
  from {
    left: -100%;
    right: 100%;
  }
  to {
   left: 100%;
    right: -100%;
  }
}
  .sk-loader{
    display: flex;
    flex-wrap: wrap;
    position: relative;
    overflow:hidden;
    .sk-loader-loading{
    position: absolute;
    top: 0;
    left: -100%;
    right: 50%;
    bottom: 0;
    background: linear-gradient(100deg, rgba(255,255,255,0) 40%, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 60%);
    background-repeat: no-repeat;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
    background-position:0px;
    }
  }
</style>